export default __webpack_public_path__ + "static/media/Remove-Cuvette.492fe0b0.svg";